/* =========================================================================
   MyVibe — Moteur de consentement cookies & traceurs (CNIL)
   -------------------------------------------------------------------------
   Catégories :
     essential : toujours actif (pas de consentement requis)
     analytics : Google Tag Manager (GTM-K66NHRSX)
     ads       : Google Ads (AW-18109455932)
     marketing : Omnisend (script in-shop)
   Règles CNIL appliquées :
     - AUCUN traceur non essentiel (GTM/Google/Omnisend) n'est chargé tant que
       le visiteur n'a pas explicitement consenti à la catégorie correspondante.
     - Le consentement est conservé 6 mois, puis réinterrogé.
     - Révocation aussi simple que le consentement : lien "Gérer mes cookies".
     - Boutons "Tout accepter" et "Tout refuser" de même rang visuel.
     - L'appel Shopify customerPrivacy.setTrackingConsent() est émis pour que
       les apps qui la respectent (ex. Omnisend) suspendent leur mesure.
   ========================================================================= */
(function () {
  'use strict';

  var GTM_ID    = 'GTM-K66NHRSX';
  var GADS_ID   = 'AW-18109455932';
  var OMNI_SRC  = 'https://cdn.shopify.com/extensions/01a0aa7a-f99f-7ab6-a36e-9673fd70d8d4/omnisend-57/assets/omnisend-in-shop.js';

  var STORAGE_KEY = 'mv_consent';
  var MAX_AGE_MS  = 1000 * 60 * 60 * 24 * 180; // 6 mois
  var SHOW_DELAY  = 700;

  var state = { analytics: false, ads: false, marketing: false, gtmLoaded: false, omniLoaded: false };

  /* ---------------- Persistance (par catégorie) ---------------- */
  function saveChoice(cats) {
    state.analytics = !!cats.analytics;
    state.ads       = !!cats.ads;
    state.marketing = !!cats.marketing;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ v: 3, ts: Date.now(), cats: {
        essential: true, analytics: state.analytics, ads: state.ads, marketing: state.marketing
      } }));
    } catch (e) {}
    syncShopify(state.analytics || state.ads || state.marketing);
    applyAnalytics();
    applyMarketing();
  }

  function readStored() {
    try {
      var rec = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!rec || !rec.ts) return null;
      if ((Date.now() - rec.ts) > MAX_AGE_MS) return null;
      if (rec.cats && typeof rec.cats === 'object') {
        return { analytics: !!rec.cats.analytics, ads: !!rec.cats.ads, marketing: !!rec.cats.marketing };
      }
      // Legacy v2 (binaire) : tracking=true => tout ON
      if (typeof rec.tracking === 'boolean') {
        return { analytics: rec.tracking, ads: rec.tracking, marketing: rec.tracking };
      }
    } catch (e) {}
    return null;
  }

  /* ---------------- API native Shopify ---------------- */
  function syncShopify(on) {
    try {
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api', version: '0.1',
          onLoad: function () {
            if (window.Shopify.customerPrivacy) {
              window.Shopify.customerPrivacy.setTrackingConsent(!!on, function () {});
            }
          }
        }]);
      }
    } catch (e) {}
  }

  /* ---------------- Google (GTM + Ads) ---------------- */
  function loadGTM() {
    if (state.gtmLoaded) return;
    state.gtmLoaded = true;
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GADS_ID;
    document.head.appendChild(s);
    var j = document.createElement('script');
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;
    document.head.appendChild(j);
    gtag('config', GADS_ID);
  }
  function applyAnalytics() { if (state.analytics || state.ads) loadGTM(); }

  /* ---------------- Omnisend (marketing) ----------------
     Le script Omnisend natif est injecté par l'app en fin de document (<defer>).
     Par ordre d'exécution des <defer>, mv-consent.js (dans <head>) tourne AVANT
     le script Omnisend : on peut donc retirer la balise native tant qu'il n'y a
     pas de consentement marketing, ce qui empêche tout événement Omnisend avant
     consentement. loadOmnisend() réinjecte ensuite le script si le visiteur consent. */
  function removeNativeOmnisend() {
    document.querySelectorAll('script[src*="omnisend-in-shop"]').forEach(function (s) { if (s.parentNode) s.parentNode.removeChild(s); });
  }
  function loadOmnisend() {
    if (state.omniLoaded) return;
    state.omniLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = OMNI_SRC;
    s.type = 'text/javascript';
    document.head.appendChild(s);
  }
  function applyMarketing() { if (state.marketing) loadOmnisend(); else removeNativeOmnisend(); }

  /* ---------------- Bandeau ---------------- */
  var BANNER = [
    '<div class="mv-consent__panel" role="dialog" aria-modal="true" aria-labelledby="mv-consent-title" tabindex="-1">',
    '  <div class="mv-consent__panel-head">',
    '    <h2 class="mv-consent__title" id="mv-consent-title">Vos cookies, votre choix</h2>',
    '    <button class="mv-consent__close" type="button" aria-label="Fermer ce panneau (refus)">&times;</button>',
    '  </div>',
    '  <div class="mv-consent__body">',
    '    <p>MyVibe utilise des cookies essentiels au fonctionnement du site, ainsi que des services tiers (mesure d’audience, publicité, marketing) qui déposent des traceurs. Vous choisissez lesquels sont activés.</p>',
    '    <p>Vous pouvez changer d’avis à tout moment via « Gérer mes cookies » dans le pied de page. Détails : <a class="mv-consent__link" href="/pages/politique-de-cookies">politique de cookies</a>.</p>',
    '    <div class="mv-consent__details">',
    '      <div class="mv-consent__cat">',
    '        <label><input type="checkbox" data-cat="essential" checked disabled aria-disabled="true"> Cookies essentiels</label>',
    '        <small>Toujours actifs (session, panier, sécurité, préférence de langue). Sans eux, le site ne fonctionne pas.</small>',
    '      </div>',
    '      <div class="mv-consent__cat">',
    '        <label><input type="checkbox" data-cat="analytics"> Mesure d’audience — Google</label>',
    '        <small>Analyse d’audience du site. Émetteur : Google LLC (data centre UE). Durée : 14 jours à 2 ans (anonymisation IP).</small>',
    '      </div>',
    '      <div class="mv-consent__cat">',
    '        <label><input type="checkbox" data-cat="ads"> Publicité — Google Ads</label>',
    '        <small>Diffusion et mesure des campagnes. Émetteur : Google LLC (data centre UE). Durée : 6 à 24 mois.</small>',
    '      </div>',
    '      <div class="mv-consent__cat">',
    '        <label><input type="checkbox" data-cat="marketing"> Marketing — Omnisend</label>',
    '        <small>Analyse du parcours d’achat. Émetteur : Omnisend (Lituanie, UE). Durée : 24 mois.</small>',
    '      </div>',
    '    </div>',
    '  </div>',
    '  <div class="mv-consent__actions">',
    '    <button class="mv-consent__btn mv-consent__btn--accept" type="button">Tout accepter</button>',
    '    <button class="mv-consent__btn mv-consent__btn--refuse" type="button">Tout refuser</button>',
    '    <button class="mv-consent__btn mv-consent__btn--custom" type="button">Personnaliser</button>',
    '    <button class="mv-consent__btn mv-consent__btn--save" type="button" hidden>Enregistrer</button>',
    '  </div>',
    '</div>'
  ].join('\n');

  function mountBanner() {
    if (document.querySelector('.mv-consent')) return;
    var wrap = document.createElement('div');
    wrap.className = 'mv-consent';
    wrap.innerHTML = BANNER;
    document.body.appendChild(wrap);
    wire(wrap);
    requestAnimationFrame(function () {
      wrap.classList.add('is-open');
      var first = wrap.querySelector('.mv-consent__btn--refuse');
      if (first) first.focus();
    });
  }

  function wire(wrap) {
    var btnAccept = wrap.querySelector('.mv-consent__btn--accept');
    var btnRefuse = wrap.querySelector('.mv-consent__btn--refuse');
    var btnCustom = wrap.querySelector('.mv-consent__btn--custom');
    var btnSave   = wrap.querySelector('.mv-consent__btn--save');
    var btnClose  = wrap.querySelector('.mv-consent__close');
    var details   = wrap.querySelector('.mv-consent__details');

    function close() { wrap.classList.remove('is-open'); wrap.hidden = true; }

    function currentCats() {
      var c = { analytics: false, ads: false, marketing: false };
      details.querySelectorAll('input[data-cat]').forEach(function (x) {
        if (x.dataset.cat in c) c[x.dataset.cat] = x.checked;
      });
      return c;
    }

    btnAccept.addEventListener('click', function () {
      saveChoice({ analytics: true, ads: true, marketing: true }); close();
    });
    btnRefuse.addEventListener('click', function () {
      saveChoice({ analytics: false, ads: false, marketing: false }); close();
    });
    btnCustom.addEventListener('click', function () {
      if (details.hasAttribute('hidden')) {
        details.removeAttribute('hidden');
        btnSave.hidden = false;
      } else {
        details.setAttribute('hidden', '');
        btnSave.hidden = true;
      }
    });
    btnSave.addEventListener('click', function () { saveChoice(currentCats()); close(); });
    btnClose.addEventListener('click', function () { saveChoice({ analytics: false, ads: false, marketing: false }); close(); });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !wrap.hidden) close();
    });
  }

  /* ---------------- Réouverture ("Gérer mes cookies") ---------------- */
  function openFromLink() {
    var wrap = document.querySelector('.mv-consent');
    if (!wrap) { mountBanner(); return; }
    wrap.hidden = false;
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    var rec = readStored();
    var det = wrap.querySelector('.mv-consent__details');
    if (det) {
      det.removeAttribute('hidden');
      var save = wrap.querySelector('.mv-consent__btn--save');
      if (save) save.hidden = false;
      det.querySelectorAll('input[data-cat]').forEach(function (c) {
        if (c.dataset.cat === 'essential') return;
        c.checked = !!(rec && rec[c.dataset.cat]);
      });
    }
  }

  /* ---------------- Démarrage ---------------- */
  function init() {
    var stored = readStored();
    if (stored) {
      state.analytics = stored.analytics; state.ads = stored.ads; state.marketing = stored.marketing;
      applyAnalytics();
      applyMarketing();
      return; // consentement déjà donné dans les 6 derniers mois : pas de bandeau
    }
    // Première visite (pas de consentement) : on retire immédiatement le script
    // Omnisend natif (fin de document) avant qu'il ne s'exécute. mv-consent.js est
    // dans <head> et les <defer> s'exécutent dans l'ordre du document, donc on est
    // avant le script Omnisend. Les traceurs Google ne sont jamais injectés tant que
    // le visiteur ne consent pas (loadGTM n'est appelé que sur consentement).
    removeNativeOmnisend();
    setTimeout(mountBanner, SHOW_DELAY);

    document.addEventListener('click', function (ev) {
      var t = ev.target.closest ? ev.target.closest('[data-mv-consent-reopen]') : null;
      if (t) { ev.preventDefault(); openFromLink(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.MVConsent = { open: openFromLink, _state: state };
})();
